module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/header-image-02-9496ff735e2e9d04026cc1fd2ea6da5e.jpg";